import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { exceptionHandler } from '../../base/decorators';
import { getXsrfToken } from '../../base/utils';
import { networkRequest } from '@tencent/ark-request';
import qs from 'qs';
import { FILE_DESC } from './cgi-path';
var FileDescRepo = /** @class */ (function () {
    function FileDescRepo() {
    }
    FileDescRepo.prototype.fetchFileDesc = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            var queryStringParams, queryString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryStringParams = { xsrf: getXsrfToken() };
                        queryString = qs.stringify(queryStringParams);
                        return [4 /*yield*/, networkRequest.post("".concat(FILE_DESC, "?").concat(queryString), { file_id: fileId })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], FileDescRepo.prototype, "fetchFileDesc", null);
    return FileDescRepo;
}());
export { FileDescRepo };
